export default __webpack_public_path__ + "static/pattern-purple-a9bd7423811da64dfd79ce2712b7f581.svg";